import { YesNo } from "../types/yes-no.type";
import Badge from "./Badge";

interface IOwnProps {
  value: YesNo;
}

const StatusBadge: React.FC<IOwnProps> = (props) => {

  const keys = {
    'Y' : 'Publish',
    'N' : 'Unpublish',
  }

  return (
    <Badge color={props.value === 'Y' ? "success": "warning"} text={keys[props.value]} badge />
  );
};

export default StatusBadge;
